meedy.factory('meedy.wizardModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.wizardService',
    function ($rootScope, applicationModel, baseModel, wizardService) {

        function VacationModel() {

            this.checkIncompleteData = function () {
                wizardService.checkIncompleteData().then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.WIZARD.CHECK_INCOMPLETE_DATA.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.WIZARD.CHECK_INCOMPLETE_DATA.ERROR, error);
                    }
                )
            };

            this.saveFirstConfiguration = function (wrapper) {
                applicationModel.actionInProgress = true;
                wizardService.saveFirstConfiguration(wrapper).then(
                    function (resources) {
                        baseModel.broadcastOperationSucceeded();
                        $rootScope.$broadcast(Event.MEEDY.WIZARD.SAVE_FIRST_CONFIGURATION.SUCCESS, resources);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.WIZARD.SAVE_FIRST_CONFIGURATION.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

        }

        return new VacationModel();
    }
]);
